import { createReducer, on } from '@ngrx/store';
import { User, UserAccount } from '../../shared/models/api/user';
import * as UserActions from '../actions/user.actions';

export interface UserState {
  user: User | null;
  permissions: string[];
  permissionsLoading: boolean;
  permissionsError: string | null;
  account: UserAccount | null;
}

export const initialState: UserState = {
  user: null,
  account: null,
  permissions: [],
  permissionsLoading: false,
  permissionsError: null,
};

export const userReducer = createReducer(
  initialState,
  on(UserActions.loginUserSuccess, (state, { user }) => ({
    ...state,
    user,
  })),
  on(UserActions.loadUserPermissions, (state) => ({
    ...state,
    permissionsLoading: true,
    permissionsError: null,
  })),
  on(UserActions.loadUserPermissionsSuccess, (state, { permissions }) => ({
    ...state,
    permissions,
    permissionsLoading: false,
    permissionsError: null,
  })),
  on(UserActions.loadUserPermissionsFailure, (state, { error }) => ({
    ...state,
    permissionsLoading: false,
    permissionsError: error,
  })),
  on(UserActions.setUserPermissions, (state, { permissions }) => ({
    ...state,
    permissions,
    permissionsLoading: false,
    permissionsError: null,
  })),
  on(UserActions.loadUserAccountSuccess, (state, { account }) => ({
    ...state,
    account,
  })),
  on(UserActions.loadUserAccountFailure, (state, { error }) => ({
    ...state,
    account: null,
  }))
);
